import { IItem, IObjectHeightAdjustable, instanceOfIObjectHeightAdjustable } from "../../../../domain/document/items";
import { IDocumentEditable } from "..";
import { AbstractDocumentItemInitializer } from "./AbstractDocumentItemInitializer";

export class ItemHeightInitializer extends AbstractDocumentItemInitializer<IObjectHeightAdjustable> {
  constructor(document: IDocumentEditable) {
    super(document, instanceOfIObjectHeightAdjustable);
  }

  protected initializeItem(source: IItem & IObjectHeightAdjustable, update: (u: (s: IItem & IObjectHeightAdjustable) => void) => void): void {
    update(s => s.adjustObjectHeight());
  }
}
